// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2E4i4","validationTips":"StatementDescriptor_validationTips__1iA0W"};